// ProjectStyles.js
import styled from 'styled-components';
import { fonts, colors } from '../../../styles/theme';

// ===== CONTAINERS =====

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  min-height: 100%;
  font-family: "Inter", ${fonts.primary};
`;

/** Página Informações: usa toda a largura útil */
export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 1.25rem 1.5rem 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1.25rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
    gap: 1rem;
  }
`;

/** Sem “caixa única” no meio — só empilha seções */
export const ProjectContent = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  box-shadow: none;
  box-sizing: border-box;
  overflow: visible;
  color: var(--text-primary);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const HubSectionBalloon = styled.section`
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 1.25rem 1.35rem 1.4rem;
  border-radius: 14px;
  background: var(--surface-1);
  border: 1px solid var(--border-default);
`;

export const HubDownloadCategoryTitle = styled.div`
  width: 100%;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--accent);
  margin: 0.75rem 0 0.5rem;

  &:first-of-type {
    margin-top: 0.15rem;
  }
`;

export const HubAreasLinkList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.35rem;
`;

export const HubAreaBlock = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
`;

export const HubAreaLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid var(--border-default);
  background: var(--surface-secondary);
  color: var(--text-primary);
  text-decoration: none;
  font-size: 0.92rem;
  font-weight: 600;
  transition: border-color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: var(--accent);
    background: var(--surface-hover);
  }

  span:last-child {
    color: var(--accent);
    font-weight: 600;
    font-size: 0.8rem;
    white-space: nowrap;
  }
`;

export const ProjectTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 1.1rem 1.35rem;
  border-radius: 14px;
  background: var(--surface-1);
  border: 1px solid var(--border-default);
  box-sizing: border-box;
`;

export const StyledSpan = styled.span`
  color: var(--text-heading);
  font-weight: 700;
  font-size: clamp(1.25rem, 2vw, 1.6rem);
  margin: 0;
  text-align: left;
  line-height: 1.25;
`;

export const SectionHeader = styled.div`
  width: 100%;
  margin: 0 0 0.85rem;
  padding: 0;
  border: none;
  background: transparent;
  box-sizing: border-box;
`;

export const SubSectionHeader = styled(SectionHeader)`
  background: transparent;
`;

export const ListItemText = styled.div`
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-secondary);
  font-weight: 700;
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const HubStatusBanner = styled.div`
  width: 100%;
  padding: 0.85rem 1.1rem;
  border-radius: 12px;
  border: 1px solid var(--border-default);
  background: var(--surface-secondary);
  color: var(--text-secondary);
  font-size: 0.9rem;
  box-sizing: border-box;
`;

export const HubTeamGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 280px), 1fr));
  gap: 12px;
`;

export const HubTeamCard = styled.div`
  width: 100%;
  min-width: 0;
  padding: 1rem 1.15rem;
  border-radius: 12px;
  background: var(--surface-secondary);
  border: 1px solid var(--border-default);
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-sizing: border-box;
  overflow: visible;
`;

export const HubTeamName = styled.div`
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-heading);
  word-break: break-word;
`;

export const HubTeamRoles = styled.div`
  font-size: 0.8rem;
  color: var(--accent);
  font-weight: 600;
  line-height: 1.4;
  word-break: break-word;
`;

export const HubTeamMeta = styled.div`
  font-size: 0.88rem;
  color: var(--text-secondary);
  line-height: 1.55;
  overflow: visible;
  word-break: break-word;

  a {
    color: var(--info);
    text-decoration: none;
    word-break: break-all;
  }

  a:hover {
    text-decoration: underline;
  }
`;

export const HubDownloadsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HubDownloadLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid var(--border-default);
  background: var(--surface-secondary);
  color: var(--text-primary);
  text-decoration: none;
  font-size: 0.88rem;
  transition: border-color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: var(--accent);
    background: var(--surface-hover);
  }

  span:last-child {
    color: var(--accent);
    font-weight: 600;
    white-space: nowrap;
  }
`;

export const HubContactLine = styled.div`
  font-size: 0.8rem;
  color: var(--text-secondary);
  margin-top: 2px;

  a {
    color: var(--info);
    text-decoration: none;
  }
`;

// ===== INFO CARDS =====

export const InfoCardsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  box-sizing: border-box;
`;

export const InfoCard = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  padding: 14px 16px;
  border-radius: 12px;
  background: var(--surface-secondary);
  border: 1px solid var(--border-default);
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-sizing: border-box;
`;

export const InfoCardLabel = styled.div`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
  color: var(--text-secondary);
  font-family: ${fonts.primary};
`;

export const InfoCardValue = styled.div`
  font-size: 0.95rem;
  font-family: ${fonts.secondary};
  color: var(--text-primary);
  line-height: 1.45;
  min-height: 1.4em;
  overflow: visible;
  word-break: break-word;

  a {
    color: var(--info);
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

export const InfoItem = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(220px, 1.2fr);
  gap: 12px 1.5rem;
  padding: 1rem 1.25rem;
  margin: 0;
  border-radius: 12px;
  background: var(--surface-1);
  border: 1px solid var(--border-default);
  box-sizing: border-box;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ListItemTextResposta = styled.div`
  font-size: 14px;
  color: var(--text-primary);
  line-height: 1.5;
  font-family: ${fonts.secondary};

  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
`;

// ===== AREAS =====

export const AreasContainer = styled.div`
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-sizing: border-box;
`;

export const AreaHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.85rem 0;
  margin: 0;
  border: none;
  background: transparent;
  border-bottom: 1px solid var(--border-default);
  box-sizing: border-box;
`;

export const AreaInfoGrid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
  box-sizing: border-box;
`;

export const AreaName = styled.strong`
  font-size: 18px;
  font-family: ${fonts.primary};
  font-weight: 600;
  color: var(--text-primary);
`;

export const ArchivedBadge = styled.span`
  background: color-mix(in srgb, var(--danger) 15%, transparent);
  color: var(--danger);
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid color-mix(in srgb, var(--danger) 40%, transparent);
`;

// ===== AREA CARDS =====

export const AreaCard = styled.div`
  width: 100%;
  margin-top: 18px;
  padding: 22px;
  border-radius: 22px;

  background: linear-gradient(135deg,
    var(--surface-overlay),
    var(--brand-blue),
    var(--surface-overlay)
  );

  backdrop-filter: blur(18px);
  border: 1px solid var(--border-subtle);
  box-shadow: var(--shadow-lg);

  box-sizing: border-box;
  position: relative;
  overflow: hidden;

  transition: all 0.4s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: var(--border-strong);
    box-shadow: var(--shadow-lg);
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(
      circle at top right,
      var(--accent-secondary-soft),
      transparent 60%
    );
    pointer-events: none;
  }
`;

export const AreaCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
`;

export const AreaCardTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  font-family: ${fonts.primary};
  background: linear-gradient(135deg, ${colors.secondary1}, ${colors.primary2});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const AreaBadges = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const AreaChip = styled.span`
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  background: ${({ variant }) =>
    variant === 'archived'
      ? 'color-mix(in srgb, var(--danger) 15%, transparent)'
      : 'var(--accent-soft)'};
  color: ${({ variant }) =>
    variant === 'archived'
      ? 'var(--danger)'
      : 'var(--accent-secondary)'};
  border: 1px solid ${({ variant }) =>
    variant === 'archived'
      ? 'color-mix(in srgb, var(--danger) 40%, transparent)'
      : 'var(--accent-soft)'};
`;

export const AreaMetaGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
`;

export const AreaMetaCard = styled.div`
  padding: 14px 16px;
  border-radius: 14px;

  background: var(--surface-glass);
  backdrop-filter: blur(12px);
  border: 1px solid var(--border-subtle);

  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AreaMetaLabel = styled.div`
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-weight: 600;
  color: var(--text-heading);
`;

export const AreaMetaValue = styled.div`
  font-size: 14px;
  font-family: ${fonts.secondary};
  color: var(--text-primary);
  word-break: break-word;
`;

export const AreaInfoCardsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 14px;
  margin-top: 12px;
`;

// ===== RESPONSIBLES =====

export const ResponsiblesContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-bottom: 18px;
  box-sizing: border-box;
`;

export const ResponsibleItem = styled.div`
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  background: var(--surface-glass);
  border: 1px solid var(--border-subtle);
  backdrop-filter: blur(10px);
  box-sizing: border-box;
`;

export const ResponsibleLabel = styled.span`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--text-heading);
`;

export const ResponsibleValue = styled.span`
  margin-top: 4px;
  font-size: 14px;
  font-family: ${fonts.secondary};
  color: var(--text-primary);
`;

export const AreaInfoCard = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  padding: 14px 22px;
  border-radius: 14px;

  background: var(--surface-glass);
  backdrop-filter: blur(12px);
  border: 1px solid var(--border-subtle);

  transition: 0.3s;
  box-sizing: border-box;

  &:hover {
    background: var(--accent-secondary-soft);
    border-color: var(--border-strong);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const AreaInfoLabel = styled.div`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-weight: 600;
  color: var(--text-heading);
  font-family: ${fonts.primary};
`;

export const AreaInfoValue = styled.div`
  font-size: 14px;
  font-family: ${fonts.secondary};
  color: ${({ color }) => color || 'var(--text-primary)'};
  line-height: 1.5;
`;

// ===== SEPARATOR =====

export const AreaSeparator = styled.hr`
  border: none;
  height: 1px;
  margin: 20px 0;
  background: linear-gradient(to right, transparent, var(--border-default), transparent);
`;

// ===== NO AREAS =====

export const NoAreasMessage = styled.div`
  width: 100%;
  padding: 1rem 1.15rem;
  border-radius: 12px;
  background: var(--surface-secondary);
  border: 1px dashed var(--border-default);
  color: var(--text-secondary);
  font-family: ${fonts.secondary};
  text-align: left;
  line-height: 1.55;
  box-sizing: border-box;
`;

export const HubListTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.86rem;

  th,
  td {
    text-align: left;
    padding: 0.55rem 0.65rem;
    border-top: 1px solid var(--border-default);
    color: var(--text-primary);
    vertical-align: top;
  }

  th {
    background: var(--table-header-bg);
    font-size: var(--table-header-font-size);
    text-transform: uppercase;
    letter-spacing: var(--table-header-letter-spacing);
    color: var(--table-header-color);
    font-weight: var(--table-header-font-weight);
    border-top: none;
  }

  a {
    color: var(--info);
    text-decoration: none;
    font-weight: 600;
  }

  a:hover {
    text-decoration: underline;
  }

  @media screen and (max-width: 768px) {
    font-size: 0.8rem;
    min-width: 520px;

    th,
    td {
      padding: 0.45rem 0.5rem;
    }
  }
`;

export const HubListTableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

export const HubBadge = styled.span`
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  border: 1px solid var(--border-default);
  background: ${({ $tone }) =>
    $tone === "danger"
      ? "color-mix(in srgb, var(--danger) 15%, transparent)"
      : $tone === "success"
        ? "color-mix(in srgb, var(--success) 15%, transparent)"
        : "var(--surface-secondary)"};
  color: ${({ $tone }) =>
    $tone === "danger"
      ? "var(--danger)"
      : $tone === "success"
        ? "var(--success)"
        : "var(--text-secondary)"};
`;

// ===== BUTTONS =====

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 12px;
  margin: 0.5rem 0 0;
  box-sizing: border-box;
`;

export const StyledButton = styled.button`
  background: ${props => props.secondary 
    ? 'var(--input-bg)' 
    : 'var(--accent-secondary-soft)'};
  border: 2px solid ${props => props.secondary 
    ? 'var(--border-default)' 
    : 'var(--accent-secondary-soft)'};
  border-radius: 14px;
  color: ${props => props.secondary 
    ? 'var(--text-primary)' 
    : 'var(--text-heading)'};
  cursor: pointer;
  padding: 10px 18px;
  text-align: center;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 13px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-width: 130px;
  min-height: 40px;
  z-index: 2;
  box-sizing: border-box;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
      ${props => props.secondary 
        ? 'var(--input-bg) 0%, var(--surface-glass) 100%' 
        : 'var(--accent-secondary-soft) 0%, var(--accent-soft) 100%'}
    );
    opacity: 0;
    transition: opacity 0.35s ease;
    border-radius: 12px;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    background: transparent;
    box-shadow: ${props => props.secondary 
      ? '0 4px 10px var(--input-bg)' 
      : '0 4px 10px var(--accent-soft)'};
    opacity: 0;
    transition: opacity 0.35s ease;
    z-index: -1;
  }

  &:hover {
    transform: translateY(-2px);
    border-color: ${props => props.secondary 
      ? 'var(--text-muted)' 
      : 'var(--accent-soft)'};
    color: var(--text-primary);

    &::before { opacity: 1; }
    &::after { opacity: 1; }
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    min-width: 115px;
    padding: 8px 16px;
    font-size: 12px;
  }
`;

export const InitializeButton = styled.button`
  background: var(--accent-secondary);
  border: none;
  border-radius: 14px;
  color: var(--brand-navy);
  cursor: pointer;
  padding: 11px 20px;
  text-align: center;
  transition: all 0.3s ease;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.4px;
  position: relative;
  overflow: hidden;
  min-width: 145px;
  min-height: 42px;
  z-index: 2;
  box-sizing: border-box;
  box-shadow: 
    0 6px 16px var(--border-strong),
    0 2px 6px var(--shadow-sm);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
      var(--border-default) 0%, 
      var(--surface-glass) 100%
    );
    opacity: 0.4;
    z-index: -1;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 
      0 10px 24px var(--border-strong),
      0 4px 10px var(--shadow-md);
  }

  &:active {
    transform: translateY(-1px);
    box-shadow: 
      0 6px 14px var(--border-strong),
      0 2px 6px var(--shadow-sm);
  }

  &:disabled {
    background: var(--border-strong);
    color: var(--text-muted);
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    min-width: 130px;
    padding: 9px 16px;
    font-size: 12px;
  }
`;